import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $profileFeatureStore } from '@lib/store';
import { FormatUtils } from '@shared/utils';
import type { UserProfileResponse } from '@shared/api/rest/users';
import { SidebarItem, SidebarRow } from '@widgets';
import { Button, Icon } from '@shared/widgets';
import ShieldIcon from '@assets/icons/shield.svg';
import UserIcon from '@assets/icons/user.svg';

interface IUserSidebarItemsProps {
  user: UserProfileResponse;
  setShowDetailsModal: () => void;
  setShowPasswordModal: () => void;
  setShowLockModal: () => void;
  setShowDeleteModal: () => void;
}

export const UserSidebarItems = (props: IUserSidebarItemsProps) => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);

  const { t } = useTranslation('user');

  if (!props.user) return null;
  return (
    <>
      <SidebarItem title={t('sidebar.profile.title')} icon={<Icon icon={<UserIcon />} color='inherit' />}>
        <SidebarRow leftRowText={t('sidebar.profile.fields.username')} rightRowText={props.user.userName} />
        <SidebarRow leftRowText={t('sidebar.profile.fields.firstName')} rightRowText={props.user.firstName} />
        <SidebarRow leftRowText={t('sidebar.profile.fields.lastName')} rightRowText={props.user.lastName} />
        {props.user.phoneAreaCode && props.user.phoneNumber && (
          <SidebarRow
            leftRowText={t('sidebar.profile.fields.phoneNumber')}
            rightRowText={FormatUtils.toPhoneFormat(props.user.phoneAreaCode, props.user.phoneNumber)}
          />
        )}
        <SidebarRow leftRowText={t('sidebar.profile.fields.positionRole')} rightRowText={props.user.position || t('sidebar.profile.fields.none')} />
        {profileFeatureStore.data?.userManagement.updateUserProfileDetails && (
          <Button color='outlined' className='mb-5' fullWidth onClick={props.setShowDetailsModal}>
            {t('buttons.editDetails', { ns: 'common' })}
          </Button>
        )}
      </SidebarItem>
      <SidebarItem title={t('sidebar.security.title')} icon={<Icon icon={<ShieldIcon />} color='inherit' />}>
        {profileFeatureStore.data?.userManagement.changeUserPassword && (
          <Button className='mb-5' fullWidth color='outlined' onClick={props.setShowPasswordModal}>
            {t('buttons.changePassword', { ns: 'common' })}
          </Button>
        )}
        {profileFeatureStore.data?.userManagement.lockOrUnlockUser && (
          <Button className='mb-5' fullWidth color='outlined' onClick={props.setShowLockModal}>
            {props.user.locked ? t('sidebar.security.buttons.unlockUser') : t('sidebar.security.buttons.lockUser')}
          </Button>
        )}
        {profileFeatureStore.data?.userManagement.deleteUser && (
          <Button className='mb-5' fullWidth color='outlined' onClick={props.setShowDeleteModal}>
            {t('sidebar.security.buttons.deleteUser')}
          </Button>
        )}
      </SidebarItem>
    </>
  );
};
